import { SiteMapPage } from '../types';

export const PURCHASE_ORDER_ISSUE = 'PURCHASE_ORDER_ISSUE';
export const RETURN_ORDER_ISSUE = 'RETURN_ORDER_ISSUE';
export const CLAIM_ISSUE = 'CLAIM_ISSUE';
export const USER_ISSUE = 'USER_ISSUE';
export const GENERAL_ISSUE = 'GENERAL_ISSUE';

export const ADD_SHIPPING_LOCATION_REQUEST = 'addShippingLocation';
export const ADD_PRICE_LIST_ITEMS_REQUEST = 'addPriceListItems';
export const PURCHASE_ORDER_REQUEST = 'purchaseOrderIssue';
export const RETURN_ORDER_REQUEST = 'returnOrderIssue';
export const CLAIM_REQUEST = 'claimIssue';
export const ACCOUNT_REQUEST = 'accountIssue';
export const OTHER_REQUEST = 'somethingElse';

export type RequestType = {
    id: string;
    labelKey: string;
    routingKey: string;
    issueType: string;
    subjectKey: string;
    contextKey?: string;
};

const SOMETHING_ELSE_REQUEST_TYPE: RequestType = {
    id: OTHER_REQUEST,
    labelKey: 'requestType-somethingElse-option',
    routingKey: 'routing-portalSupport-text',
    issueType: GENERAL_ISSUE,
    subjectKey: 'requestSubject-somethingElse-text',
};

export const REQUEST_TYPES: RequestType[] = [
    {
        id: ADD_SHIPPING_LOCATION_REQUEST,
        labelKey: 'requestType-addShippingLocation-option',
        routingKey: 'routing-salesOperations-text',
        issueType: PURCHASE_ORDER_ISSUE,
        subjectKey: 'requestSubject-addShippingLocation-text',
    },
    {
        id: ADD_PRICE_LIST_ITEMS_REQUEST,
        labelKey: 'requestType-addPriceListItems-option',
        routingKey: 'routing-salesOperations-text',
        issueType: PURCHASE_ORDER_ISSUE,
        subjectKey: 'requestSubject-addPriceListItems-text',
        contextKey: 'requestContext-addPriceListItems-text',
    },
    {
        id: PURCHASE_ORDER_REQUEST,
        labelKey: 'requestType-purchaseOrderIssue-option',
        routingKey: 'routing-salesOperations-text',
        issueType: PURCHASE_ORDER_ISSUE,
        subjectKey: 'requestSubject-purchaseOrderIssue-text',
    },
    {
        id: RETURN_ORDER_REQUEST,
        labelKey: 'requestType-returnOrderIssue-option',
        routingKey: 'routing-returnsSupport-text',
        issueType: RETURN_ORDER_ISSUE,
        subjectKey: 'requestSubject-returnOrderIssue-text',
    },
    {
        id: CLAIM_REQUEST,
        labelKey: 'requestType-claimIssue-option',
        routingKey: 'routing-claimsSupport-text',
        issueType: CLAIM_ISSUE,
        subjectKey: 'requestSubject-claimIssue-text',
    },
    {
        id: ACCOUNT_REQUEST,
        labelKey: 'requestType-accountIssue-option',
        routingKey: 'routing-portalSupport-text',
        issueType: USER_ISSUE,
        subjectKey: 'requestSubject-accountIssue-text',
    },
    SOMETHING_ELSE_REQUEST_TYPE,
];

const DEFAULT_REQUEST_BY_ISSUE_TYPE: Record<string, string> = {
    [PURCHASE_ORDER_ISSUE]: PURCHASE_ORDER_REQUEST,
    [RETURN_ORDER_ISSUE]: RETURN_ORDER_REQUEST,
    [CLAIM_ISSUE]: CLAIM_REQUEST,
    [USER_ISSUE]: ACCOUNT_REQUEST,
};

export function requestTypeById(id: string): RequestType {
    return REQUEST_TYPES.find((requestType) => requestType.id === id) ?? SOMETHING_ELSE_REQUEST_TYPE;
}

export function defaultRequestTypeForIssueType(issueType: string): RequestType {
    return requestTypeById(DEFAULT_REQUEST_BY_ISSUE_TYPE[issueType] ?? OTHER_REQUEST);
}

export function requestTypeForPage(page: string): string | undefined {
    return page === SiteMapPage.reviewPurchaseOrderExtraction ? PURCHASE_ORDER_REQUEST : undefined;
}
